import React from 'react';
import { Input } from 'antd';

const { Search } = Input;
const search = (props) => {
    return <Search
        placeholder='Хайх...'
        onSearch={props.search}
        style={{ width: 200 }}
    ></Search>;
}

export default search;